import { gql } from '@apollo/client';

// Self-contained operations: types come from
// `npm run codegen:account-disqualification -- <backend checkout>`.

const DISQUALIFICATION_FIELDS = gql`
  fragment CpmAccountDisqualificationFields on CpmAccountDisqualification {
    id
    user_id
    user_name
    platform
    account_label
    reason
    affected_count
    refunded_cents
    retained_cents
    disqualified_by_name
    created_at
    lifted_at
    lifted_by_name
    restored_at
    restorable
  }
`;

export const ADMIN_CPM_CAMPAIGN_ACCOUNT_DISQUALIFICATIONS = gql`
  query AdminCpmCampaignAccountDisqualifications($campaignId: ID!) {
    adminCpmCampaignAccountDisqualifications(campaignId: $campaignId) {
      ...CpmAccountDisqualificationFields
    }
  }
  ${DISQUALIFICATION_FIELDS}
`;

export const ADMIN_CPM_ACCOUNT_DISQUALIFICATION_PREVIEW = gql`
  query AdminCpmAccountDisqualificationPreview($submissionId: ID!) {
    adminCpmAccountDisqualificationPreview(submissionId: $submissionId) {
      platform
      account_label
      campaign_type
      affected_count
      reversed_cents
      refunded_cents
      retained_cents
      already_active
    }
  }
`;

export const ADMIN_CPM_ACCOUNT_RESTORE_PREVIEW = gql`
  query AdminCpmAccountRestorePreview($disqualificationId: ID!) {
    adminCpmAccountRestorePreview(disqualificationId: $disqualificationId) {
      restorable_count
      skipped_count
      full_amount_cents
      capped_amount_cents
      budget_charge_cents
      capped_budget_charge_cents
      budget_remaining_cents
      cap_exceeded
      over_cap_cents
      budget_missing_cents
      user_disqualified
      ranking_finalized
    }
  }
`;

export const MY_CPM_CAMPAIGN_ACCOUNT_DISQUALIFICATIONS = gql`
  query MyCpmCampaignAccountDisqualifications($campaignId: ID!) {
    myCpmCampaignAccountDisqualifications(campaignId: $campaignId) {
      id
      platform
      account_label
      reason
      created_at
    }
  }
`;

export const ADMIN_DISQUALIFY_CPM_CAMPAIGN_ACCOUNT = gql`
  mutation AdminDisqualifyCpmCampaignAccount($submissionId: ID!, $reason: String!) {
    adminDisqualifyCpmCampaignAccount(submissionId: $submissionId, reason: $reason) {
      ...CpmAccountDisqualificationFields
    }
  }
  ${DISQUALIFICATION_FIELDS}
`;

export const ADMIN_LIFT_CPM_CAMPAIGN_ACCOUNT_DISQUALIFICATION = gql`
  mutation AdminLiftCpmCampaignAccountDisqualification(
    $disqualificationId: ID!
    $restoreClips: Boolean!
    $forceCapped: Boolean
  ) {
    adminLiftCpmCampaignAccountDisqualification(
      disqualificationId: $disqualificationId
      restoreClips: $restoreClips
      forceCapped: $forceCapped
    ) {
      ...CpmAccountDisqualificationFields
    }
  }
  ${DISQUALIFICATION_FIELDS}
`;

export const ADMIN_RESTORE_CPM_CAMPAIGN_ACCOUNT_CLIPS = gql`
  mutation AdminRestoreCpmCampaignAccountClips($disqualificationId: ID!, $forceCapped: Boolean) {
    adminRestoreCpmCampaignAccountClips(disqualificationId: $disqualificationId, forceCapped: $forceCapped) {
      ...CpmAccountDisqualificationFields
    }
  }
  ${DISQUALIFICATION_FIELDS}
`;
